export default __webpack_public_path__ + "static/media/about-img.81fe92df.png";